<script lang="ts" setup>
import type { HTMLAttributes } from "vue"
import { Textarea } from "~/components/ui/textarea"
import { cn } from "~/lib/utils"

const { class: cl } = defineProps<{
    class?: HTMLAttributes["class"]
}>()
</script>

<template>
    <Textarea
        v-bind="$attrs"
        :class="cn('text-base', cl)"
    />
</template>